import React from 'react';

import './ExpertList.scss';

export default function ExpertList(props) {
  return (
    <section className="expertList">
      <ul className="expertList_items">
        {props.experts.map(({ content }) => (
          <li
            key={content.id}
            className="expertList_item"
            onClick={() => {
              if (props.actionOnClick) props.actionOnClick();

              location.href = content.uri;
            }}
          >
            <div className="expertList_item_content">
              <div
                alt="expert-image"
                className="expertList_image"
                style={{ backgroundImage: `url("${content.imageUrl}")` }}
              >
                <div className="expertList_image_overlay" />
              </div>

              <div className="expertList_info">
                <div>
                  <p className="expertList_title">{content.title}</p>

                  <p className="expertList_subtitle">{content.subTitle}</p>
                </div>

                <button className="expertList_button">Bekijken</button>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
